import APProfilePhoto from "./APProfilePhoto";

export { APProfilePhoto };

export default APProfilePhoto;
